import { render } from "./InterestedPartner.vue?vue&type=template&id=5ad97737"
import script from "./InterestedPartner.vue?vue&type=script&lang=js"
export * from "./InterestedPartner.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\SCFHSHealthAcademy\\SCFHSHealthAcademyPublic\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__